// extracted by mini-css-extract-plugin
module.exports = {"CommentsButton":"CommentsButton_CommentsButton__1NTy0"};